import React from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import ManageWatchlistDialog from 'components/watchlist/ManageWatchlist/ManageWatchlist';
import wrapWithErrorBoundary from 'global/ErrorBoundary';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'global/agGridCustomStyles.css';
import { useMediaQuery } from '@material-ui/core';
import { COLLAPSED_SIDEBAR_WIDTH, HEADER_HEIGHT, SIDEBAR_WIDTH } from 'config/appConfig';
import 'react-perfect-scrollbar/dist/css/styles.css';

const MainTheme = ({ children }) => {
  const sidebarToggle = useSelector(state => state.ThemeOptions.sidebarToggle);
  const watchlistDialog = useSelector(state => state.Watchlist.watchlistDialog);
  const isSentimentDrawerOpen = useSelector(state => state.Sentiment.isSentimentDrawerOpen);

  const isLgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });
  const isSmDown = useMediaQuery(theme => theme.breakpoints.down('sm'), { noSsr: true });
  return (
    <>
      {wrapWithErrorBoundary(<Header />)}
      {wrapWithErrorBoundary(<Sidebar />)}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          paddingTop: HEADER_HEIGHT,
          minHeight: '100vh',
          paddingLeft: !sidebarToggle && isLgUp ? SIDEBAR_WIDTH : isLgUp ? COLLAPSED_SIDEBAR_WIDTH : 0,
          paddingRight: isSentimentDrawerOpen && isLgUp ? 400 : 0,
          transition: 'all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1)',
        }}>
        <div style={{ flex: 1, padding: isSmDown ? '1rem 0.1rem 0.5rem 0.11rem' : '1rem 0.5rem 0.5rem 1rem' }}>
          {children}
        </div>
        {wrapWithErrorBoundary(<Footer />)}
      </div>
      {watchlistDialog ? wrapWithErrorBoundary(<ManageWatchlistDialog />) : null}
    </>
  );
};

export default MainTheme;
